import React, { Component } from "react";
import { connect } from "react-redux";
import {
	decorateWithParenthesis,
	convertHoursToInt,
	departureRuleDawn,
	departureRuleMorning,
	departureRuleAfternoon,
	departureRuleNight,
	filterLabels,
	outputFilteredFlights,
	getDepartureString
} from "../shared/utils";

import { setFilter } from "../actions";
import R from "ramda";

const orderedDepartures = [
	{ name: "madrugada", interval: "00:00 às 05:59 " },
	{ name: "manha", interval: "06:00 às 11:59 " },
	{ name: "tarde", interval: "12:00 às 17:59 " },
	{ name: "noite", interval: "18:00 às 23:59 " }
];

class FilterFlightsWrapper extends Component {
	isChecked(attribute, stretch, value) {
		//cuidado, se tiver esperando value com 0 ele vai cair no return hein bb

		if (!attribute || !stretch || !value) return;

		return this.props.selectedFilters[stretch][attribute].indexOf(value) > -1;
	}

	decorateStops(stops) {
		if (stops > 0) return stops == 1 ? "1 Parada" : stops + " Paradas";

		if (stops == "direct") return "Voo direto";

		return null;
	}

	renderAirlines(airlines, stretch) {
		if (airlines) {
			const opositeStretch = stretch === "outbound" ? "inbound" : "outbound";
			const oppositeFlight =
				this.props.selectedFlights[opositeStretch].length === 1
					? this.props.selectedFlights[opositeStretch][0]
					: undefined;

			airlines.sort((a, b) => {
				return a.toLowerCase() > b.toLowerCase() ? 1 : -1;
			});

			return airlines.map(airline => {
				// Não exibir airline quando não for a mesma do voo já selecionado
				if (this.props.isInternational && oppositeFlight && airline !== oppositeFlight.airline) {
					return null;
				}

				const num = this.props.filterProps[stretch].allFlights.filter(flight => {
					return flight.airline === airline;
				}).length;

				const checked = this.isChecked("airlines", stretch, airline);

				return (
					<div key={airline} className="checkbox">
						<input
							type="checkbox"
							className="styled-checkbox"
							data-action="filter-cia"
							disabled={oppositeFlight && this.props.isInternational}
							id={airline + "_filter"}
							checked={checked}
							onChange={e => this.props.setFilter({ airlines: airline }, this.props.currentStretch)}
							aria-label={`${airline} ${decorateWithParenthesis(num)}`}
						/>
						<label htmlFor={airline + "_filter"} data-action="filter-cia" className="selected">
							{airline} {decorateWithParenthesis(num)}
						</label>
					</div>
				);
			});
		}

		return null;
	}

	renderDepartureTimes(departures, stretch) {
		if (departures) {
			return orderedDepartures.reduce((orderedDeparture, departure) => {
				if (departures.includes(departure.name)) {
					const num = this.props.filterProps[stretch].allFlights.filter(flight => {
						const time = convertHoursToInt(flight.departureDate);

						if (departure.name == "madrugada" && departureRuleDawn(time)) return flight;
						if (departure.name == "manha" && departureRuleMorning(time)) return flight;
						if (departure.name == "tarde" && departureRuleAfternoon(time)) return flight;
						if (departure.name == "noite" && departureRuleNight(time)) return flight;
					}).length;

					orderedDeparture.push(
						<div key={departure.name} className="checkbox">
							<input
								type="checkbox"
								className="styled-checkbox"
								id={departure.name + "_filter"}
								data-action="filter-departure-time"
								checked={this.isChecked("departureTimes", stretch, departure.name)}
								onChange={e =>
									this.props.setFilter(
										{ departureTimes: departure.name },
										this.props.currentStretch
									)
								}
								aria-label={`${departure.name} - ${departure.interval} ${decorateWithParenthesis(
									num
								)}`}
							/>
							<label
								htmlFor={departure.name + "_filter"}
								data-action="filter-departure-time"
								className="selected"
							>
								{filterLabels[departure.name].name}
								{` - ${departure.interval}`}
								{decorateWithParenthesis(num)}
							</label>
						</div>
					);
				}
				return orderedDeparture;
			}, []);
		}
	}

	renderAirports(airports, directionAttribute, stretch) {
		if (airports) {
			const fromOrTo = directionAttribute == "originAirports" ? "from" : "to";

			if (airports)
				return airports.map(airport => {
					const num = this.props.filterProps[stretch].allFlights.filter(flight => {
						return flight[fromOrTo] === airport;
					}).length;

					return (
						<div key={airport} className="checkbox">
							<input
								type="checkbox"
								className="styled-checkbox"
								id={airport + "_filter"}
								data-action={"filter-airport-" + fromOrTo}
								checked={this.isChecked(directionAttribute, stretch, airport)}
								onChange={e =>
									this.props.setFilter({ [directionAttribute]: airport }, this.props.currentStretch)
								}
								aria-label={`${airport} ${decorateWithParenthesis(num)}`}
							/>
							<label
								htmlFor={airport + "_filter"}
								data-action={"filter-airport-" + fromOrTo}
								className="selected"
							>
								{airport} {decorateWithParenthesis(num)}
							</label>
						</div>
					);
				});
		}

		return null;
	}

	renderFeeTypes(feeTypes, stretch) {
		if (feeTypes) {
			const numMAX = this.props.filterProps[stretch].allFlights.filter(flight => {
				return flight.otaAvailableIn !== "airline" && flight.pricing.mmBestPriceAt === "miles";
			}).length;

			const numConvencionais = this.props.filterProps[stretch].allFlights.filter(flight => {
				return flight.otaAvailableIn !== "airline" && flight.pricing.mmBestPriceAt === "ota";
			}).length;

			return (
				<div>
					<div key="max" className="checkbox">
						<input
							type="checkbox"
							className="styled-checkbox"
							data-action="filter-passages"
							id="passagens-max"
							checked={this.isChecked("feeTypes", stretch, "passagemMax")}
							onChange={e => this.props.setFilter({ feeTypes: "passagemMax" }, stretch)}
							aria-label={`MAX ${decorateWithParenthesis(
								numMAX
							)} - Nas Passagens MAX, você pode encontrar descontos ainda maiores e utilizar cupons, créditos e cashbacks.`}
						/>
						<label htmlFor="passagens-max" data-action="filter-passages" className="selected">
							Max {decorateWithParenthesis(numMAX)}{" "}
							<i
								className="tooltip gray"
								data-tooltip="Nas Passagens MAX, você pode encontrar descontos ainda maiores e utilizar cupons, créditos e cashbacks."
								data-flow="down"
							>
								?
							</i>
						</label>
					</div>

					<div key="convencional" className="checkbox">
						<input
							type="checkbox"
							data-action="filter-passages"
							className="styled-checkbox"
							id="passagens-convencionais"
							checked={this.isChecked("feeTypes", stretch, "passagemConvencional")}
							onChange={e => this.props.setFilter({ feeTypes: "passagemConvencional" }, stretch)}
							aria-label={`Convencionais ${decorateWithParenthesis(
								numConvencionais
							)} - Nas Passagens Convencionais, não é possível utilizar cupons, créditos e cashbacks.`}
						/>
						<label
							htmlFor="passagens-convencionais"
							data-action="filter-passages"
							className="selected"
						>
							Convencionais {decorateWithParenthesis(numConvencionais)}{" "}
							<i
								className="tooltip gray"
								data-tooltip="Nas Passagens Convencionais, não é possível utilizar cupons, créditos e cashbacks."
								data-flow="down"
							>
								?
							</i>
						</label>
					</div>
				</div>
			);
		}

		return null;
	}

	outputStop(stop, stretch, num) {
		return (
			<div key={stop} className="checkbox">
				<input
					type="checkbox"
					className="styled-checkbox"
					id={stop + "_filter"}
					data-action="filter-stops"
					checked={this.isChecked("stops", stretch, stop)}
					onChange={e => this.props.setFilter({ stops: stop }, this.props.currentStretch)}
					aria-label={`${this.decorateStops(stop)} ${decorateWithParenthesis(num)}`}
				/>
				<label htmlFor={stop + "_filter"} data-action="filter-stops" className="selected">
					{this.decorateStops(stop)} {decorateWithParenthesis(num)}
				</label>
			</div>
		);
	}

	renderSteppedStops(stops, stretch) {
		if (stops) {
			return stops
				.filter(stop => stop !== "direct")
				.sort()
				.map(stopsData => {
					const num = this.props.filterProps[stretch].allFlights.filter(flight => {
						return flight.stops === stopsData;
					}).length;

					return this.outputStop(stopsData, stretch, num);
				});
		}
	}

	renderDirectStops(stops, stretch) {
		if (stops) {
			return stops.filter(stop => stop == "direct").map(stopsData => {
				const num = this.props.filterProps[stretch].allFlights.filter(flight => {
					return flight.stops === stopsData;
				}).length;

				return this.outputStop(stopsData, stretch, num);
			});
		}
	}

	showLazyLoadEffect(label) {
		if (this.props.showLazyLoad) return <div className="lazyload">{label}</div>;

		return <h3 className="new-card__subtitle">{label}</h3>;
	}

	render() {
		const currentStretch = this.props.currentStretch;
		const filterProps = this.props.filterProps[currentStretch];

		return (
			<div className={`new-card filter-flights ${this.props.showMobileFilters ? 'no-shadow no-bold no-padding': ' hidden-xs hidden-sm'}`}>
				<header className="new-card__header">
					<h4 className="new-card__title">Filtre resultados por</h4>
				</header>
				<div className="new-card__content">
					<div className="filter-label" role="group" aria-label="Filtrar por paradas">
						{this.showLazyLoadEffect("Paradas")}
						<div>
							{this.renderDirectStops(filterProps.stops, currentStretch)}
							{this.renderSteppedStops(filterProps.stops, currentStretch)}
						</div>
					</div>

					<div className="filter-label" role="group" aria-label="Filtrar por horário de partida">
						{this.showLazyLoadEffect("Horário de partida")}
						<div>{this.renderDepartureTimes(filterProps.departureTimes, currentStretch)}</div>
					</div>

					<div className="filter-label" role="group" aria-label="Filtrar por aeroportos de partida">
						{this.showLazyLoadEffect("Aeroportos de partida")}
						<div>
							{this.renderAirports(filterProps.originAirports, "originAirports", currentStretch)}
						</div>
					</div>

					<div className="filter-label" role="group" aria-label="Filtrar por aeroportos de chegada">
						{this.showLazyLoadEffect("Aeroportos de chegada")}
						<div>
							{this.renderAirports(
								filterProps.destinationAirports,
								"destinationAirports",
								currentStretch
							)}
						</div>
					</div>

					<div className="filter-label" role="group" aria-label="Filtrar por companhia aérea">
						{this.showLazyLoadEffect("Companhia aérea")}
						<div>{this.renderAirlines(filterProps.airlines, currentStretch)}</div>
					</div>
				</div>
			</div>
		);
	}
}

const mapStateToProps = state => {
	const buildFilter = (flights, stretch) => {
		const currentStretch = stretch;

		let allFlights = flights[currentStretch];
		let airlines,
			departureTimes,
			originAirports,
			destinationAirports,
			feeTypes,
			stops = [];

		allFlights.forEach(function(flight) {
			const fee =
				flight.otaAvailableIn !== "airline" && flight.pricing.mmBestPriceAt === "miles"
					? "tarifaMax"
					: "";

			airlines = R.union([flight.airline], airlines);
			destinationAirports = R.union([flight.to], destinationAirports);
			originAirports = R.union([flight.from], originAirports);
			stops = R.union([flight.stops], stops);
			departureTimes = R.union([getDepartureString(flight.departureDate)], departureTimes);
			feeTypes = R.union([fee], feeTypes);
		});

		return {
			airlines,
			destinationAirports,
			originAirports,
			stops,
			departureTimes,
			feeTypes,
			allFlights: outputFilteredFlights(allFlights, state.selectedFilters[stretch])
		};
	};

	return {
		filterProps: {
			outbound: buildFilter(state.flights, "outbound"),
			inbound: buildFilter(state.flights, "inbound")
		},
		showLazyLoad: state.searchStatus.progress < 45 && state.flights.flightsFound === 0,
		currentStretch: state.flightsTab.currentStretch,
		selectedFilters: state.selectedFilters,
		selectedFlights: state.selectedFlights,
		isInternational: state.searchStatus.isInternational
	};
};

const mapDispatchToProps = dispatch => ({
	setFilter: (filter, stretch) => {
		dispatch(setFilter(filter, stretch));
	}
});

export default connect(mapStateToProps, mapDispatchToProps)(FilterFlightsWrapper);
